<template>
    <div>
        <q-list class="q-pa-none q-ma-none">
            <div class="row">
                <div class="col text-start text-h6">{{title}}</div>
                <div class="col text-start">page {{pagination.page}} of {{pagination.rowsNumber}}</div>
            </div>
            <div v-for="row in rows" :key="row.id">
                <q-item bordered class="q-px-none">
                    <q-item-section avatar class="q-px-xs">
                        <q-icon v-if="row.isPerk" name="img:/assets/icons/trophy.svg" />
                        <q-icon v-else name="img:/assets/icons/plus.svg" />
                    </q-item-section>

                    <q-item-section>
                        <q-item-label class="text-left">{{row.message}}</q-item-label>
                        <q-item-label caption class="text-left" lines="2">{{row.createdAtAgo}}<q-icon size="sm" color="grey" name="mdi-circle-small" /> {{row.createdAt}} </q-item-label>
                    </q-item-section>

                    <q-item-section side class="q-px-xs">
                        <q-icon name="chevron_right" v-if="merchant" color="primary" @click="selectActivity(row)"  dense />
                    </q-item-section>
                </q-item>            
                <div class="justify-center q-mx-xl q-px-xl">
                    <q-separator inset size="2px"></q-separator>
                </div>
            </div>
        </q-list>

        <div class="row justify-end">
            <q-btn flat label="Prev" v-if="pagination.page > 1" @click="paginate(pagination.page - 1)"></q-btn>
            <q-separator inset vertical size="2px"></q-separator>
            <q-btn flat v-if="pagination.page < pagination.rowsNumber" label="Next" @click="paginate(pagination.page + 1)"></q-btn>
        </div>
    </div>
</template>

<script>
import router from "@/router";
import { useStore } from 'vuex'
export default {
    name: 'points-history',
    props: ['rows', 'title', 'pagination', 'merchant'],
    setup(props, context) {
        const store = useStore()
        const paginate = (page) => {
            context.emit('paginate', page)
        }

        const selectActivity = (row) => {
            if (row) {
                localStorage.setItem('place', row.placeId)
                localStorage.setItem('customer', row.user.id)
                localStorage.setItem('customerName', row.customer)

                store.commit('setHUser', {
                    id: row.user.id,
                    name: row.user.name ?? 'Anonymous'
                })

                router.push('/points/history/merchant')
            }
        }

        return {paginate, selectActivity}
    },
}
</script>
